import React, { useState, useEffect } from 'react';

const AppLoadingHandler = ({ children }) => {
  useEffect(() => {
    // Update viewport height
    const updateViewportHeight = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    // Initialize viewport height
    updateViewportHeight();

    // Add event listeners
    window.addEventListener('resize', updateViewportHeight);
    window.addEventListener('orientationchange', () => {
      setTimeout(updateViewportHeight, 100);
    });

    // We no longer need the 'isStylesLoaded' state, as the initial 
    // HTML loader handles the visual loading part. We just run the setup logic.
    // The main app will be rendered immediately by React.

    // Cleanup listeners on component unmount
    return () => {
      window.removeEventListener('resize', updateViewportHeight);
      window.removeEventListener('orientationchange', updateViewportHeight);
    };
  }, []);

  // Directly render the children without a loading check.
  return children;
};

export default AppLoadingHandler;